"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var mobx_react_1 = require("mobx-react");
var Nav_1 = __importDefault(require("./Nav"));
var TopBar_1 = __importDefault(require("./top-bar/TopBar"));
var NavState_1 = require("../contexts/NavState");
var use_nav_state_1 = require("hooks/use-nav-state");
var use_stores_1 = require("hooks/use-stores");
var Logout_1 = __importDefault(require("./Logout"));
var logo_white_svg_1 = __importDefault(require("res/img/logo-white.svg"));
var GanttChart_1 = __importDefault(require("./gantt-chart/GanttChart"));
var Clients_1 = __importDefault(require("./clients/Clients"));
var AddClient_1 = __importDefault(require("./clients/add-client/AddClient"));
var EditClient_1 = __importDefault(require("./clients/edit-client/EditClient"));
var SettingsPage_1 = __importDefault(require("./settings/SettingsPage"));
var UserStore_1 = require("../stores/UserStore");
var Users_1 = __importDefault(require("./users/Users"));
var AddUser_1 = __importDefault(require("./users/add-user/AddUser"));
var EditUser_1 = __importDefault(require("./users/edit-user/EditUser"));
var Profile_1 = __importDefault(require("./profile/Profile"));
var Root = mobx_react_1.observer(function () {
    var _a = react_1.useState(false), loaded = _a[0], setLoaded = _a[1];
    var location = react_router_dom_1.useLocation();
    var history = react_router_dom_1.useHistory();
    var navState = use_nav_state_1.useNavState();
    var userStore = use_stores_1.useStores().userStore;
    var search = location.search;
    var fromLogin = new URLSearchParams(search).get('login');
    var loginTimeout = react_1.useRef(null);
    var loadedTimeout = react_1.useRef(null);
    var zoom, theme;
    if (userStore.data) {
        zoom = userStore.data.settings.generalSettings.zoom;
        theme = userStore.data.settings.generalSettings.theme;
    }
    react_1.useEffect(function () {
        if (fromLogin !== null) {
            clearTimeout(loginTimeout.current);
            loginTimeout.current = setTimeout(function () {
                history.replace(location.pathname.replace('?login=true', ''));
            }, 1500);
        }
        clearTimeout(loadedTimeout.current);
        loadedTimeout.current = setTimeout(function () {
            setLoaded(true);
        }, 1200);
        return function () {
            clearTimeout(loginTimeout.current);
        };
    }, []);
    react_1.useEffect(function () {
        document.documentElement.setAttribute('data-zoom', zoom.toString());
    }, [zoom]);
    var toggleHandler = function () {
        navState.saveState(navState.state === NavState_1.NavState.NOT_COLLAPSED ?
            NavState_1.NavState.COLLAPSED :
            NavState_1.NavState.NOT_COLLAPSED);
    };
    return (react_1.default.createElement("div", { className: "root flex flex-row", "data-loaded": loaded, "data-light-theme": theme === UserStore_1.Themes.LIGHT },
        react_1.default.createElement(Nav_1.default, { collapsed: navState.state, onCollapseToggle: toggleHandler, userRoles: userStore.data && userStore.data.roles || [] }),
        react_1.default.createElement("div", { className: "root__main flex flex-column", "data-nav-collapsed": navState.state === NavState_1.NavState.COLLAPSED },
            react_1.default.createElement(TopBar_1.default, { name: userStore.data && userStore.data.firstName || null, theme: theme }),
            react_1.default.createElement(react_router_dom_1.Switch, null,
                react_1.default.createElement(react_router_dom_1.Route, { path: '/gantt-chart', component: GanttChart_1.default })),
            react_1.default.createElement(react_router_dom_1.Switch, null,
                react_1.default.createElement(react_router_dom_1.Route, { path: '/clients', component: Clients_1.default })),
            react_1.default.createElement(react_router_dom_1.Switch, null,
                react_1.default.createElement(react_router_dom_1.Route, { path: '/users', component: Users_1.default })),
            react_1.default.createElement(react_router_dom_1.Route, { path: '/clients/edit/:id', component: EditClient_1.default }),
            react_1.default.createElement(react_router_dom_1.Route, { path: '/clients/add-client', component: AddClient_1.default }),
            react_1.default.createElement(react_router_dom_1.Route, { path: '/users/edit/:id', component: EditUser_1.default }),
            react_1.default.createElement(react_router_dom_1.Route, { path: '/users/add-user', component: AddUser_1.default }),
            react_1.default.createElement(react_router_dom_1.Route, { path: '/settings', component: SettingsPage_1.default }),
            react_1.default.createElement(react_router_dom_1.Route, { path: '/profile', component: Profile_1.default }),
            react_1.default.createElement(react_router_dom_1.Route, { path: '/logout', component: Logout_1.default })),
        fromLogin === null &&
            react_1.default.createElement("div", { className: 'root-logo flex flex-column flex-center' },
                react_1.default.createElement("img", { src: logo_white_svg_1.default, alt: 'RWD' }))));
});
exports.default = Root;
